export default "__VITE_ASSET__DvfYqEUr__"